// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { bannerStyles } from "@sc/Overrides/Widgets/Basic/Banner";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

bannerStyles.overlayWrapper = {
    css: css`
        text-align: left;
        display: flex;
        flex-direction: column;
        padding: 32px 16px 32px 22px;
        ${xScreen("lte", "md")} {
            padding: 20px 16px;
        }
    `,
};

bannerStyles.heading = {
    size: 24,
    lineHeight: "32px",
    weight: "bold",
    css: css`
        margin-bottom: 16px;
    `,
};

bannerStyles.subHeading = {
    size: 18,
    weight: "bold",
    lineHeight: "24px",
    css: css`
        margin-bottom: 8px;
        &&& {
            ${TypographyStyle} {
                line-height: 24px;
                margin-bottom: 0;
                font-size: 18px;
                font-weight: bold;
            }
        }
    `,
};
bannerStyles.content = {
    size: 16,
    lineHeight: "26px",
    css: css`
        margin-bottom: 16px;
    `,
};

bannerStyles.bannerButton = {
    css: css`
        max-width: max-content;
    `,
};
